import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "24",
  fill: "none",
  viewBox: "0 0 26 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "26",
      height: "5",
      y: ".5",
      fill: "currentColor",
      rx: "2.5"
    }, null, -1),
    _createElementVNode("rect", {
      width: "15",
      height: "5",
      x: "11",
      y: "9.5",
      fill: "currentColor",
      rx: "2.5"
    }, null, -1),
    _createElementVNode("rect", {
      width: "20",
      height: "5",
      x: "6",
      y: "18.5",
      fill: "currentColor",
      rx: "2.5"
    }, null, -1)
  ])))
}
export default { render: render }